<template>
  <Card tag="form" class="project-flatfinder-mutate-basis" @submit.prevent="$emit('submit')">
    <template #default>
      <div class="project-flatfinder-mutate-basis__input">
        <InputComponent
          v-model="value.name"
          data-field="name"
          :label="labels.name"
          required
          :is-valid="validator.fields.name.valid"
          :validation-message="validator.fields.name.error"
        />
        <CheckboxComponent v-model="value.isEntry" :label="$t('flatfinderIsEntry')" />
        <InputComponent :label="$t('parent')">
          <FlatfinderSelect
            v-model="value.parent"
            :label="$t('parent')"
            :items="getFlatfinders"
            search
            class="elder-input__element"
          />
        </InputComponent>
        <MediaComponent
          v-model="value.image"
          :label="labels.image"
          :upload-options="{ compression: { maxWidth: 1920 } }"
          data-field="image"
          size="contain"
          required
          :description="false"
        >
          <template #after-label>
            <MediaRecommendation value="flatfinder" />
          </template>
        </MediaComponent>
      </div>
    </template>
  </Card>
</template>

<script>
import { i18n } from '@/i18n'
import FlatfinderApi from '@/api/Flatfinder'
import { Nest } from '@/components/Flatfinder/utils'

import Card from '@/components/Card'
import FlatfinderSelect from '@/components/Flatfinder/Resources/Select/Modal'
import { InputComponent } from 'vue-elder-input'
import { CheckboxComponent } from 'vue-elder-checkbox'
import { MediaComponent } from '@kvass/media'
import MediaRecommendation from '@/components/MediaRecommendation'

const meta = {
  order: 1,
  id: 'basis',
  label: i18n.tc('basis'),
  icon: ['fal', 'file-alt'],
}

export { meta }
export default {
  props: {
    value: Object,
    project: String,
    labels: Object,
    validator: Object,
  },
  methods: {
    getFlatfinders(filter) {
      return FlatfinderApi.get({
        filter: {
          ...filter,
          project: this.project,
          exclude: this.value.id ? [this.value.id] : undefined,
        },
      }).then(Nest)
    },
  },
  components: {
    Card,
    InputComponent,
    FlatfinderSelect,
    CheckboxComponent,
    MediaComponent,
    MediaRecommendation,
  },
}
</script>

<style lang="scss">
.project-flatfinder-mutate-basis {
  max-width: 900px;

  [data-field='image'] {
    .kvass-media-droparea {
      min-height: 500px;
    }
  }

  &__input {
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: $form-gap;
  }
}
</style>
